import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import getDepartmentAllParams from "@/types/responses/getDepartmentAllParams"
import getPagenateDepartment from  "@/types/responses/getPagenateDepartment"
import getOperationOffice from "@/types/responses/getOperationOffice"
import getDepartmentResponse from "@/types/responses/getDepartment"
import { Ref, ref, onMounted, computed } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import i18n from "@/lang/i18n"

type queryParamsType = {
  parent_id: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ParentDepartmentAutoComplete',
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    exceptionId: {},
    operationOffice: {},
    departmentId: {},
    isDepartment: { type: Boolean },
    isChildDepartment: { type: Boolean },
    errorMessages: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props

const departments: Ref<(getDepartmentResponse | getDepartmentAllParams)[]> = ref([])

onMounted( async () => {
  await new Promise((resolve) => {
    resolve(getDepartments())
  })
  if (props.departmentId || props.isDepartment) setDepartment()
})

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
})

async function getDepartments() {
  if (props.isChildDepartment) {
    await Api().getDepartments(undefined).then((data: getPagenateDepartment) => {
      departments.value = data.data
    })
  } else {
    const queryParams: queryParamsType = {parent_id: 'null'}
    await Api().autoCompleteDepartments(queryParams).then((data: getDepartmentResponse[]) => {
      departments.value = data
    })
  }
}

const filteredDepartments = computed(() => {
  let filteredItems: (getDepartmentResponse | getDepartmentAllParams)[] = departments.value
  if (props.operationOffice) {
    filteredItems = filteredItems.filter((item: getDepartmentResponse | getDepartmentAllParams) => {
      if (props.isChildDepartment) {
        return item?.operation_office_id === props.operationOffice?.id
      } else {
        return item.operationOfficeId === props.operationOffice?.id
      }
    })
  }

  if (props.exceptionId) {
    filteredItems = filteredItems.filter((item) => {
      return item.id != props.exceptionId
    })
  }
  isIncludedCandidates(filteredItems)

  return filteredItems
})

function setDepartment() {
  let department = departments.value.find((item) => item.id === props.departmentId)
  if (props.isDepartment && !props.exceptionId) department = departments.value[0]
  if (props.isChildDepartment) department = departments.value[0]?.parent_department
  if (department) modelValue.value = department
}

function isIncludedCandidates(filteredItems: (getDepartmentResponse | getDepartmentAllParams)[]) {
  const isLength = filteredItems.filter((item: getDepartmentResponse | getDepartmentAllParams) => {
    item.id == props.departmentId
  })?.length
  if (!isLength) modelValue.value = null
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!

  return (_openBlock(), _createBlock(_component_v_autocomplete, _mergeProps({
    label: _unref(i18n).global.t('pages.common.autocomplete.department'),
    modelValue: modelValue.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue).value = $event)),
    items: filteredDepartments.value,
    "item-title": "name",
    "item-value": "name"
  }, { 'return-object': true }, {
    disabled: props.disabled,
    readonly: props.isChildDepartment,
    clearable: !props.isChildDepartment,
    "error-messages": props.errorMessages
  }), null, 16, ["label", "modelValue", "items", "disabled", "readonly", "clearable", "error-messages"]))
}
}

})